import React from "react"

const LoadingSign = ({visible}) => {
  return (visible &&
    <div className="text-center">
      <div className="loading-sign">
        <span className="ball-1" />
        <span className="ball-2" />
        <span className="ball-3" />
        <span className="ball-4" />
        <span className="ball-5" />
        <span className="ball-6" />
        <span className="ball-7" />
        <span className="ball-8" />
      </div>
    </div>
  )
}

export default LoadingSign
